module.exports = __webpack_public_path__ + "img/pick_your_package.bf098118.svg";